import { Table, TableBody, TableCell, TableContainer, TableRow, makeStyles } from '@material-ui/core'
import React from 'react'
import { ValueRenderer } from '../decorative'
import { cn } from '../styles'

export const StatsList = ({
  items,
  tableThreshold = 4,
}: {
  items: IStatsListItem[]
  tableThreshold?: number
}) => {
  return items.length > tableThreshold ? <StatsTable items={items} /> : <StatsCounters items={items} />
}

const StatsTable = ({ items }: { items: IStatsListItem[] }) => {
  const { tableRow } = useStyles()

  return <TableContainer>
    <Table size="small">
      <TableBody>
        { items.map((item, i) => <TableRow className={tableRow} key={i}>
          <TableCell className="counter-title">{item.title}</TableCell>
          <TableCell className="counter-value">
            <ValueRenderer value={item.value} />
          </TableCell>
        </TableRow>) }
      </TableBody>
    </Table>
  </TableContainer>
}

const StatsCounters = ({ items }: { items: IStatsListItem[] }) => {
  const { counterWrapper, counterSingle } = useStyles()
  return <ul
    className={cn(counterWrapper, {
      [counterSingle]: items.length === 1,
    })}>
    { items.map((item, i) => <li key={i}>
      <span className="counter-value">{item.value}</span>
      <span className="counter-title">{item.title}</span>
    </li>) }
  </ul>
}

export interface IStatsListItem {
  title: string
  value: any
}

const useStyles = makeStyles({
  counterWrapper: {
    width: '100%',
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',

    '& li': {
      padding: 32,
      textAlign: 'center',
    },

    '& .counter-title': {
      display: 'block',
    },

    '& .counter-value': {
      display: 'block',
      fontSize: 64,
      margin: 6,
    },
  },
  counterSingle: {
    '& .counter-value': {
      fontSize: 98,
    },
  },
  tableRow: {
    transition: 'background ease-in-out .4s',
    border: 0,

    '&:hover': {
      background: '#EEE',
    },

    '& .counter-title': {
      borderBottom: 0,
    },

    '& .counter-value': {
      borderBottom: 0,
      fontWeight: 'bold',
      textAlign: 'right',
    },
  },
})
